import React, { Component } from 'react';
import Axios from 'axios';
import Constant from '../Constant';

import '../../css/style.css';
import $ from 'jquery';
import { getAccessToken } from '../../hooks/AccessToken';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';


class VideoManagement extends Component {
      
    state = {
        ERROR: true,
        VideoList: [],
        selectValue: '', 
        length: '',
        defaultPageNo: 1,
        searchKey: '',
        sortByAttribute: 1
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }; 

    updateVideo = (event) => {
        this.props.history.push('/update-video/' + event);
    }

//----------------------------------Change status-----------------------------------------------\\

changeStatus = async (event, status, type) => {
    try {
        let token = getAccessToken();
        let metaData = {
            'status': (status) ? 0 : 1,
            'isDeleted': ''
        }

        if(type === 2) {
            metaData = { 'feature': (status) ? 0 : 1 }
        }
       
        const response = await Axios.patch(Constant.apiBasePath + 'video/changeStatus/'+ event, metaData, { headers: { 'token': token }});
        let {data} = response;
        if(data.status === Constant.statusSuccess) {
            $('#gen-message').text(data.message);
            $('#gen-message').css('color', 'green');
            window.scrollTo(0, 0);
            window.$("#myModal").modal("hide");
            this.handleSubmit(this.state.defaultPageNo);
            setTimeout(function() { $("#gen-message").text(''); }, 3000);
        }
        else {
            $('#popup-message').text(data.message);
            $('#popup-message').css('color', 'red');
            setTimeout(function() { $("#gen-message").text(''); }, 3000);
        }    
    }
    catch(err) {
        console.log(err);
    }
} 

//------------------------------------Integrate API for remove data-------------------------------//

delete = async event => {
    try {
        let token = getAccessToken();
        const response = await Axios.delete(Constant.apiBasePath + 'video/delete/' + event, { headers: { 'token': token }});
        let data = response.data;
        if(data.status === Constant.statusSuccess) {
            $('#gen-message').text(data.message);
            $('#gen-message').css('color', 'green');
            window.scrollTo(0, 0);
            this.handleSubmit(this.state.defaultPageNo);
            setTimeout(function() { $("#gen-message").text(''); }, 3000);
        }
        else {
            $('#gen-message').text(data.message);
            $('#gen-message').css('color', 'red');
            setTimeout(function() { $("#gen-message").text(''); }, 3000);
        }  

    }
    catch(err) {
        console.log(err);
    }
}


//----------------------------------Integrate API for show data----------------------------------\\

handleSubmit = async (event, sort) => {
    try {
        let token = getAccessToken();
        let selectValue = $("#selectValue").val();
        const response = await Axios.post(Constant.apiBasePath + 'video/get-all', { 'key': selectValue, 'pageNo': event }, { headers: { 'token': token }});
        const {data, length, pageNo} = response.data;
        this.setState({VideoList: data, length: length, pageNo: pageNo, defaultPageNo: event, selectValue:'', 'searchKey': '', ERROR: false});
    }
    catch(err) {
        console.log(err);
    }
}

//--------------------------------------------Reload component----------------------------------------------// 

componentDidMount() {
    this.handleSubmit(this.state.defaultPageNo);
}


//-------------------------------------------End API-------------------------------------------------------\\     

render() {
    const {VideoList, length, pageNo} = this.state;
    let i = (pageNo - 1) * Constant.perPage;

    let bodyData = '';
    if(VideoList.length > 0) {
        bodyData = VideoList.map(el => {
            i++;
            let status = "Active";
            if(el.status === 0) {
                status = "Inactive";
            }

            let feature = "Feature";
            if(el.feature === 0) {
                feature = "UnFeature";
            }
            
                        return (
                            <tr key={el._id}>
                                <td>{i}</td>
                                <td>{el.title}</td>
                                <td>{el.description}</td>
                                <td>
                                    <img src={el.thumbnail} alt="story-tent" style={{ width: 50, heigth: 50}}/>
                                </td>
                                <td>{el.totalView}</td>
                                <td className="multimedia-toggle-col">
                                    <button className="btn btn-info tblbtns multimedia-toggle-btn" onClick = {()=>{this.changeStatus(el._id, el.status, 1)}}>{status}</button>
                                </td>
                                <td className="multimedia-toggle-col">
                                    <button className="btn btn-info tblbtns multimedia-toggle-btn" onClick = {()=>{this.changeStatus(el._id, el.feature, 2)}}>{feature}</button>
                                </td>
                                <td className="actions-col multimedia-actions-col">
                                    <div className="multimedia-actions-wrap">
                                        <button
                                            type="button"
                                            className="contest-icon-btn danger"
                                            title="Delete video"
                                            aria-label="Delete video"
                                            onClick={() => {
                                                if(window.confirm('Delete the video?')) {
                                                    this.delete(el._id)
                                                }
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: '13px' }} />
                                        </button>
                                        <button
                                            type="button"
                                            className="contest-icon-btn"
                                            title="Update video"
                                            aria-label="Update video"
                                            onClick={() => {this.updateVideo(el._id)}}
                                        >
                                            <FontAwesomeIcon icon={faEdit} style={{ fontSize: '13px' }} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )
        })
    }

        let previous = 0;
        let next = 0;
        let customLength = 0

        if(pageNo !== 0) {
            previous = pageNo - 1;
            next = pageNo + 1;
        }

        if(length !== 0) {
            customLength = length;
        }

        if(length < 2) {
           $(".pagination").hide();
        }

   
        return (
                <div className="content-page contest-submissions-page contest-management-page multimedia-management-page video-management-page event-consistent-page">
                   <div className="content page-content-spaced">
                        <div className="event-management-header">
                            <div className="header-content">
                                <div className="header-title">
                                    <h4 className="page-title-heading">Video Management</h4>
                                    <p className="header-subtitle">Manage video assets, feature flags, and publish status.</p>
                                </div>
                                <div className="header-actions">
                                    <Link to="/add-video" className="btn btn-primary btn-add-event contest-add-match">+ Add New</Link>
                                </div>
                            </div>
                        </div>

                        <div className="event-management-body">
                            <div className="card contest-like-card">
                                <div className="card-body">
                                    <div className="multimedia-management-toolbar">
                                        <div className="multimedia-management-filter-group">
                                            <select id="selectValue" onChange={()=>{this.handleSubmit(this.state.defaultPageNo)}} className="form-control">
                                                <option value="all">Select one</option>
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>
                                        <p id="gen-message" className="message-feedback"></p>
                                    </div>

                                    <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                                        {
                                            (VideoList.length > 0)
                                            ?
                                            <table id="complex-header-datatable" className="table event-table contest-submissions-table contest-like-table multimedia-management-table">
                                                <thead>
                                                    <tr>
                                                        <th className="multimedia-sno-col">S.No.</th>
                                                        <th style={{width:'20%'}}>Title</th>
                                                        <th style={{width:'30%'}}>Description</th>
                                                        <th className="multimedia-thumb-col">Thumbnail</th>
                                                        <th className="multimedia-views-col">Total View</th>
                                                        <th className="multimedia-toggle-col">Status</th>
                                                        <th className="multimedia-toggle-col">Feature</th>
                                                        <th className="actions-col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bodyData}
                                                </tbody>
                                            </table>
                                            :
                                            <p>No video found.</p>
                                        }

                                        {
                                            (length > 1)
                                            ?
                                                <div className="pagination">
                                                {
                                                    (pageNo <= 1) ?
                                                <a>Previous</a>
                                                :
                                                <a className="paginate-link" onClick={() => this.handleSubmit(previous)}>Previous</a>
                                                }

                                                <a>{pageNo}</a>
                                                {
                                                    (pageNo >= customLength)
                                                    ?
                                                <a>Next</a>
                                                :
                                                <a className="paginate-link active" onClick={() => this.handleSubmit(next)}>Next</a>

                                                }
                                                </div>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }    
        
}
export default VideoManagement;
